// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/chevron-left.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/chevron-right.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendarGrid{
    display: flex;
    flex-direction: column;
    gap: 15px;
    height: 100%;
    padding: 16px 22px;
    position: relative;
    background: #f9f9f6;
}

.calendarGrid_header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
    margin-top: 2px;
}

.calendarGrid_month{
    display: flex;
    align-items: center;
    gap: 5px;
}

.calendarGrid_arrow{
    width: 18px;
    height: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    font-size: 0;
    cursor: pointer;
} 

.calendarGrid_arrow_left{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.calendarGrid_arrow_right{

}

.calendarGrid_month_value{
    font-weight: 400;
    font-size: calc(16px * var(--fontScaler));
    line-height: 100%;
    display: flex;
    align-items: center;
    color: #000000;
}

.calendarGrid_container{
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
}

.calendarGrid_scroll_container{
    flex: 1;
    overflow-x: auto;
    overflow-y: auto;
    width: 100%;
}

.calendarGrid_days_header{
    display: grid;
    grid-template-columns: 80px repeat(var(--days-count), 100px);
    background: #f8f9fa;
    border-bottom: 1px solid #e0e0e0;
    position: sticky;
    top: 0;
    z-index: 10;
    width: calc(80px + var(--days-count) * 100px);
    min-width: calc(80px + var(--days-count) * 100px);
}

.calendarGrid_time_header{
    width: 80px;
    flex-shrink: 0;
    border-right: 1px solid #e0e0e0;
}

.calendarGrid_day_header{
    padding: 8px 4px;
    text-align: center;
    border-right: 1px solid #e0e0e0;
}

.calendarGrid_day_header:last-child{
    border-right: none;
}

.calendarGrid_day_number{
    font-weight: 600;
    font-size: 14px;
    color: #000;
}

.calendarGrid_day_name{
    font-size: 12px;
    color: #666;
    text-transform: uppercase;
}

.calendarGrid_body{
    flex: 1;
    width: calc(80px + var(--days-count) * 100px);
    min-width: calc(80px + var(--days-count) * 100px);
}

.calendarGrid_time_row{
    display: grid;
    grid-template-columns: 80px repeat(var(--days-count), 100px);
    min-height: 40px;
    border-bottom: 1px solid #e0e0e0;
    width: calc(80px + var(--days-count) * 100px);
    min-width: calc(80px + var(--days-count) * 100px);
}

.calendarGrid_time_row:last-child{
    border-bottom: none;
}

.calendarGrid_time_slot{
    width: 80px;
    flex-shrink: 0;
    padding: 8px;
    border-right: 1px solid #e0e0e0;
    background: #f8f9fa;
    font-size: 12px;
    color: #666;
    text-align: center;
    font-weight: 500;
}

.calendarGrid_cell{
    border-right: 1px solid #e0e0e0;
    position: relative;
    cursor: pointer;
    min-height: 40px;
}

.calendarGrid_cell:hover{
    background: #f0f9ff;
}

.calendarGrid_cell:last-child{
    border-right: none;
}

.calendarGrid_ticket{
    position: absolute;
    left: 2px;
    right: 2px;
    background: var(--ticket-color-back);
    border-radius: 4px;
    border-left: 3px solid var(--ticket-color-side);
    padding: 2px 4px;
    cursor: pointer;
    overflow: hidden;
    z-index: 5;
    min-height: 25px;
}

.calendarGrid_ticket:hover{
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    z-index: 6;
}

.calendarGrid_ticket_content{
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.calendarGrid_ticket_time{
    font-size: 9px;
    font-weight: 600;
    color: var(--ticket-color);
    opacity: 0.8;
    line-height: 1;
}

.calendarGrid_ticket_title{
    font-size: 10px;
    font-weight: 500;
    color: var(--ticket-color);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.1;
}

.calendarGrid_ticket--colorA {
    --ticket-color-side: rgba(14, 165, 233, 1);
    --ticket-color-back: rgba(14, 165, 233, 0.1);
    --ticket-color: #0369A1;
}

.calendarGrid_ticket--colorB {
    --ticket-color-back: rgba(139, 92, 246, 0.1);
    --ticket-color-side: #8B5CF6;
    --ticket-color: #6D28D9;
}

.calendarGrid_ticket--colorC {
    --ticket-color: #B45309;
    --ticket-color-side: #F59E0B;
    --ticket-color-back: rgba(245, 158, 11, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/components/calendarGrid/CalendarGrid.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,4BAA4B;IAC5B,sBAAsB;IACtB,yDAAsD;IACtD,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yDAAuD;AAC3D;;AAEA;;AAEA;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,6CAA6C;IAC7C,iDAAiD;AACrD;;AAEA;IACI,WAAW;IACX,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,OAAO;IACP,6CAA6C;IAC7C,iDAAiD;AACrD;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,gBAAgB;IAChB,gCAAgC;IAChC,6CAA6C;IAC7C,iDAAiD;AACrD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,YAAY;IACZ,+BAA+B;IAC/B,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,oCAAoC;IACpC,kBAAkB;IAClB,+CAA+C;IAC/C,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;IACtC,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,0BAA0B;IAC1B,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,0CAA0C;IAC1C,4CAA4C;IAC5C,uBAAuB;AAC3B;;AAEA;IACI,4CAA4C;IAC5C,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;IAC5B,4CAA4C;AAChD","sourcesContent":[".calendarGrid{\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    height: 100%;\n    padding: 16px 22px;\n    position: relative;\n    background: #f9f9f6;\n}\n\n.calendarGrid_header{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 5px;\n    margin-top: 2px;\n}\n\n.calendarGrid_month{\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.calendarGrid_arrow{\n    width: 18px;\n    height: 18px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-image: url('../../assets/chevron-left.svg');\n    font-size: 0;\n    cursor: pointer;\n} \n\n.calendarGrid_arrow_left{\n    background-image: url('../../assets/chevron-right.svg');\n}\n\n.calendarGrid_arrow_right{\n\n}\n\n.calendarGrid_month_value{\n    font-weight: 400;\n    font-size: calc(16px * var(--fontScaler));\n    line-height: 100%;\n    display: flex;\n    align-items: center;\n    color: #000000;\n}\n\n.calendarGrid_container{\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n}\n\n.calendarGrid_scroll_container{\n    flex: 1;\n    overflow-x: auto;\n    overflow-y: auto;\n    width: 100%;\n}\n\n.calendarGrid_days_header{\n    display: grid;\n    grid-template-columns: 80px repeat(var(--days-count), 100px);\n    background: #f8f9fa;\n    border-bottom: 1px solid #e0e0e0;\n    position: sticky;\n    top: 0;\n    z-index: 10;\n    width: calc(80px + var(--days-count) * 100px);\n    min-width: calc(80px + var(--days-count) * 100px);\n}\n\n.calendarGrid_time_header{\n    width: 80px;\n    flex-shrink: 0;\n    border-right: 1px solid #e0e0e0;\n}\n\n.calendarGrid_day_header{\n    padding: 8px 4px;\n    text-align: center;\n    border-right: 1px solid #e0e0e0;\n}\n\n.calendarGrid_day_header:last-child{\n    border-right: none;\n}\n\n.calendarGrid_day_number{\n    font-weight: 600;\n    font-size: 14px;\n    color: #000;\n}\n\n.calendarGrid_day_name{\n    font-size: 12px;\n    color: #666;\n    text-transform: uppercase;\n}\n\n.calendarGrid_body{\n    flex: 1;\n    width: calc(80px + var(--days-count) * 100px);\n    min-width: calc(80px + var(--days-count) * 100px);\n}\n\n.calendarGrid_time_row{\n    display: grid;\n    grid-template-columns: 80px repeat(var(--days-count), 100px);\n    min-height: 40px;\n    border-bottom: 1px solid #e0e0e0;\n    width: calc(80px + var(--days-count) * 100px);\n    min-width: calc(80px + var(--days-count) * 100px);\n}\n\n.calendarGrid_time_row:last-child{\n    border-bottom: none;\n}\n\n.calendarGrid_time_slot{\n    width: 80px;\n    flex-shrink: 0;\n    padding: 8px;\n    border-right: 1px solid #e0e0e0;\n    background: #f8f9fa;\n    font-size: 12px;\n    color: #666;\n    text-align: center;\n    font-weight: 500;\n}\n\n.calendarGrid_cell{\n    border-right: 1px solid #e0e0e0;\n    position: relative;\n    cursor: pointer;\n    min-height: 40px;\n}\n\n.calendarGrid_cell:hover{\n    background: #f0f9ff;\n}\n\n.calendarGrid_cell:last-child{\n    border-right: none;\n}\n\n.calendarGrid_ticket{\n    position: absolute;\n    left: 2px;\n    right: 2px;\n    background: var(--ticket-color-back);\n    border-radius: 4px;\n    border-left: 3px solid var(--ticket-color-side);\n    padding: 2px 4px;\n    cursor: pointer;\n    overflow: hidden;\n    z-index: 5;\n    min-height: 25px;\n}\n\n.calendarGrid_ticket:hover{\n    box-shadow: 0 2px 8px rgba(0,0,0,0.15);\n    z-index: 6;\n}\n\n.calendarGrid_ticket_content{\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.calendarGrid_ticket_time{\n    font-size: 9px;\n    font-weight: 600;\n    color: var(--ticket-color);\n    opacity: 0.8;\n    line-height: 1;\n}\n\n.calendarGrid_ticket_title{\n    font-size: 10px;\n    font-weight: 500;\n    color: var(--ticket-color);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    line-height: 1.1;\n}\n\n.calendarGrid_ticket--colorA {\n    --ticket-color-side: rgba(14, 165, 233, 1);\n    --ticket-color-back: rgba(14, 165, 233, 0.1);\n    --ticket-color: #0369A1;\n}\n\n.calendarGrid_ticket--colorB {\n    --ticket-color-back: rgba(139, 92, 246, 0.1);\n    --ticket-color-side: #8B5CF6;\n    --ticket-color: #6D28D9;\n}\n\n.calendarGrid_ticket--colorC {\n    --ticket-color: #B45309;\n    --ticket-color-side: #F59E0B;\n    --ticket-color-back: rgba(245, 158, 11, 0.1);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
